<template>
    <div>
        <h3>{{ this.$store.getters.getHeaderSubtext }}</h3>
        <img class="img-fluid d-block mx-auto image" :src=" (this.company_logo) ? this.company_logo : ''">
        <h3 class="text-center">{{ this.company_name}}</h3>
        <p class="text-center">{{ this.header_text }}</p>
    </div>
</template>

<script>
import APIService from "../services/api_service";

export default {
    name: 'Header',
    components:{},
    data(){
        return {
            display_header: true,
            company_id: 0,
            custom_header : true,
            company_logo: '',
            company_name: '',
            header_text: ''
        }
    },
    created(){

        this.company_id = document.getElementById('co_id').value;
        
        APIService.getConfigurations(this.company_id)
        .then((json) => {

            this.company_logo = json.widget_company_image;
            this.company_name = json.name;
            this.header_text = json.widget_company_text;
        });

    }
}
</script>

<style scoped>
    .image{
        width: 100%;
        max-width: 300px;
        height: auto;
        object-fit: cover;
    }
</style>